import { InputAdornment, TextField, type SxProps } from '@mui/material';

import { Icon } from '../shared/icon';

export const SearchTextBox = ({
  sx,
  value,
  onChange,
  placeholder,
  hideIcon,
  onEnter,
}: {
  sx?: SxProps;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  hideIcon?: boolean;
  onEnter?: () => void;
}) => {
  return (
    <TextField
      sx={{
        '.MuiInputBase-root': {
          height: '32px',
          paddingLeft: '4px',
          paddingRight: '4px',
        },
        '.MuiInputBase-input': {
          ...(!hideIcon && { paddingLeft: 0 }),
        },
        '.MuiInputAdornment-root': {
          margin: '0px',
        },
        ...sx,
      }}
      value={value}
      onKeyDown={onEnter && ((e) => e.key === 'Enter' && onEnter())}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      InputProps={{
        startAdornment: !hideIcon && (
          <InputAdornment position='start'>
            <Icon iconClass='material-symbols-search' />
          </InputAdornment>
        ),
        endAdornment: value && (
          <InputAdornment position='end'>
            <Icon
              iconClass='material-symbols-close-rounded'
              onClick={() => onChange('')}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};
